// Cache configuration
const cacheDays = 7;
const CACHE_KEY = 'uploads_cache';

function getCache() {
  try {
    const cache = localStorage.getItem(CACHE_KEY);
    return cache ? JSON.parse(cache) : null;
  } catch (error) {
    console.error('[uploadsCache] Error reading cache:', error);
    return null;
  }
}

function setCache(cache) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
  } catch (error) {
    console.error('[uploadsCache] Error writing cache:', error);
  }
}

/**
 * Pull uploads from cache
 * Returns cached uploads object or null if not found
 * @returns {Object|null} Cached uploads object or null
 */
export function pullFromCache() {
  return getCache();
}

/**
 * Save uploads to cache
 * Filters uploads older than cacheDays
 * @param {Object} uploads - The uploads object to cache
 */
export function saveToCache(uploads) {
  const now = new Date();
  const cutoffDate = new Date(now.getTime() - cacheDays * 24 * 60 * 60 * 1000);
  
  const filteredUploads = {};
  Object.entries(uploads).forEach(([id, upload]) => {
    const uploadDate = new Date(upload.createdAt);
    if (uploadDate > cutoffDate) {
      filteredUploads[id] = upload;
    }
  });
  
  setCache(filteredUploads);
}
